/**
 * Standard page header. Ported verbatim from the original app.
 */

import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}

export function PageHeader({ title, subtitle, action }: PageHeaderProps) {
  return (
    <header className="flex items-center justify-between px-4 pt-[max(16px,env(safe-area-inset-top))] pb-4">
      <div>
        <h1 className="display" style={{ fontSize: '1.9rem' }}>{title}</h1>
        {subtitle && (
          <p className="text-sm" style={{ color: 'var(--cream-muted)' }}>
            {subtitle}
          </p>
        )}
      </div>
      {action && <div>{action}</div>}
    </header>
  );
}
